// src/components/ErrorMessage.jsx
import React from "react";
import { FiAlertCircle } from "react-icons/fi";

/**
 * Standardized Error Message Component
 * @param {string} message - Error message to display
 * @param {string} className - Optional CSS class name
 * @param {object} style - Optional inline styles
 */
export default function ErrorMessage({ message, className = "", style = {} }) {
  if (!message) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className={className}
      style={{
        background: "#fef2f2",
        color: "#b91c1c",
        border: "1px solid #fecaca",
        padding: "12px 16px",
        borderRadius: 10,
        fontSize: 14,
        marginBottom: 15,
        display: "flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      <FiAlertCircle size={16} style={{ flexShrink: 0 }} />
      <span>{message}</span>
    </div>
  );
}
